module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3d01caa7b3aaa53cfd249a1a7a22f7fb.png";